export default "__VITE_ASSET__JPU$jtxQ__"